import { type Media } from "@package/ui-gql/index-data-access";

export function createMediaCacheName(media: Media) {
  return `${media.id}-${media.file}`;
}
